import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import ContractorGroupService from "../../services/contractor/contractorgroup.service";
import { ColorEditor } from '../../components/grid/CustomEditors/ColorEditor';

import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
  OnEventArgs,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { InputAdornment, TextField } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import BorderSpinner from '../../components/Layout/spinner';


const location = window.location
  
const locationley = location.pathname.replace('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};


class ContractorGroups extends BaseGrid {
  
    title = 'Grupy kontrahentów';
    subTitle = 'Zarządzanie grupami kontrahentów'
 constructor(public readonly props: BasicGridProps) {
    super(props);
   
    
 }


 getLookups(){
  return ContractorGroupService.getLookups().then(response => {

        let tmp1: LookupCollection[] = []
        if ((response.data) && (Array.isArray(response.data))){
            tmp1  = response.data
        }
        this.setState((state: State) => ({
          ...state,
          lookupData : tmp1
        }),  () => {
          
            this.defineGrid()
          }
          
        );
  }
     
  ).catch(
    () => {
      let tmp : LookupData[] = [];
      this.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
      }));
      return tmp;
    }
  )
}
  
componentDidMount() {
  window.addEventListener("resize",((e: any) =>{
    setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
    
 }).bind(this));

  
this.getLookups();
// this.defineGrid()

    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl");
      
    });
  
}

 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);

    if (presets){
      var new_sorters = presets.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;
    }
   
    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state: State) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}

componentDidUpdate(PrevProps: any, prevState: State){
  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){
      if (this.state.alertErrorMsg){
      //  alert(this.state.alertErrorMsg)
      }
  }   
  
}


  getGridDefinition(): GridOption {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: '#smaller-container',
          rightPadding: 10
        },
        enableExcelExport : true,
        excelExportOptions: {
          sanitizeDataExport: true
        },
        externalResources: [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()],
        
        editCommandHandler: (_item:any, _column:Column<any>, editCommand:EditCommand) => {
          var data = _item
  
          this._commandQueue.push(editCommand);
          editCommand.execute();
          this.editGroupApiCall(data);
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            return this.getGroupApiCall(query)},
          postProcess: (response) => {
            this.setState(
              (state: State) => ({ ...state, metrics: response.metrics }),
              () => this.postProcessCallback(response)
            );
            this.displaySpinner(false);
          },
        } as OdataServiceApi
      }
    return tmp;
  }

  onCellValidationError(_e: Event, args: any) {
    if (args.validationResults) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: args.validationResults.msg
      }));
    }
  }



  nameValidator :EditorValidator = (value: any) => {
    
    let ready=false
    if (value === null || value === undefined || !value.length) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertErrorMsg: []
      }));
      return { valid: false, msg: 'To pole jest wymagane' };
    }else if (value.length>100) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertErrorMsg: []
      }));
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 100 znaków',
      };

    }else{
      var selectRow =this.reactGrid.slickGrid.getSelectedRows();
      var id=-1
      if (selectRow.length ==1){
        if (this.reactGrid.slickGrid.getDataItem(selectRow[0])){
          id = this.reactGrid.slickGrid.getDataItem(selectRow[0]).id
        }
      }
      ContractorGroupService.groupExist(value, id).then(response => {
            if (response >0){
              
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Nazwa grupy: " + value + " już istnieje!",
              }));
          
            }else{
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertErrorMsg: []
              }));
            }
      }
      ).catch(
        (error) => {
          this.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertError: error
      }));
        }
      )
    }
   
    return { valid: true, msg: '' };
  };

  groupFormatter =  (row: any, cell: any, value: any, columnDef: any, dataContext: any) => {
    var s="";
    if (dataContext.user_names !=null){
        if (Array.isArray(dataContext.user_names)){
            s = dataContext.group_names.join(',');
        }else{
            var array = dataContext.user_names.split(',');
            
            for (var a in array ) {
            if (s!=""){
                s+=", ";
            }	
              
            s += array[a];
            
            }
        }
    
    }
     return s;
 };


 
nameFormatter = (row: any, cell: any, value: any, columnDef: any, dataContext: any) =>{
  var ownContractor = authService.isAdmin() 
  var s='';
  if ( dataContext.name !=null){
      s ="<a class='slickRowLink' href='/contractors?group_name=" + value+ "' >" + dataContext.name + "</a>";
  }
  return s;
};

onUserNamesChange(e: Event, args: OnEventArgs){
  if (args.columnDef.field == 'user_names_array'){
      if (Array.isArray(args.dataContext['user_names_array']))
        args.dataContext['user_names'] = args.dataContext['user_names_array'].join(', ')
  }else{
    args.dataContext['user_names'] = ''
  }
}


  getColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let tmp : Column[] = [];
    let data_users: any[] = [];
    this.state.lookupData?.forEach((item) => {
      if (item.name === 'users'){
        data_users = item.data; 
      } 
    })

    if (authService.isAdmin()){
      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteGroupFormatter.bind(this) as Formatter
          },    
        }
      );
    }

    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
        {
          id: 'name', name: 'Nazwa grupy', field: 'name', sortable: true, filterable: true,
          excludeFromColumnPicker: true,
          type: FieldType.string,
          formatter:this.nameFormatter,
          //formatter:this.taskTranslateFormatter,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
          editor: {model: Editors.text,
            validator : this.nameValidator,
            maxLength:100,
            compositeEditorFormOrder : 1,
            
          },
          hidden:false,
          minWidth:100
               
        },
         {
                id: 'not_reported', name: 'Nie raportowany', field: 'not_reported', sortable: true, filterable: true,
                type: FieldType.boolean,
                formatter: Formatters.checkmark,
                filter: {
                  model: Filters.singleSelect,
                  collection: [
                    { value: '', label: '' },
                    { value: 1, label: 'Tak' },
                    { value: 0, label: 'Nie' },
                  ],
                },
                editor: {model: Editors.checkbox,
                  compositeEditorFormOrder : 14,
                },
                
                minWidth:50
              },
        {
          id: 'user_names_array', name: 'Handlowcy', field: 'user_names_array', sortable: true, filterable: true,
          type: FieldType.string,
          formatter: this.groupFormatter,
          filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_users},
          editor: {model: Editors.multipleSelect,
            collection: data_users,
            compositeEditorFormOrder : 5,
          },
          onCellChange: this.onUserNamesChange,
          queryField: 'user_names',
          minWidth:100
        },
    );
    tmp = this.customizeHeaderMenu(tmp)
    return tmp
  }


  deleteGroupFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Usuń';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Grupa:</div> <div>${dataContext.name}</div></div>`;
  }

  getGroupApiCall(query: string) {
    return ContractorGroupService.getgroups(query)
  }
  editGroupApiCall(data: any) {   
    ContractorGroupService.editgroup(data).then(
      
      ).catch(
         (error) => {
          try{
            this._commandQueue.pop()?.undo()
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }

  sortCollectionDescending(collection: any[]) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openCompositeModal(modalType: CompositeEditorModalType) {
    let modalTitle = '';
    if (this.reactGrid.slickGrid.getEditorLock().isActive() && !this.reactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowej grupy';
          break;
        case 'clone':
          modalTitle = 'Kopiowanie grupy - {{name}}';
          break;
        case 'edit':
          var selecttedcount =  this.reactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych rekordów (' + selecttedcount + ')';
            modalType = 'mass-selection';
          }else{
            modalTitle = 'Edycja grupy'; // 'Editing - {{title}} ({{product.itemName}})'
          }
          break;
      }
      var modalColumns = this.reactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstance?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          onSave: (formValues, selection, dataContext) => {

              if (Array.isArray(dataContext['user_names_array']))
                dataContext['user_names'] = dataContext['user_names_array'].join(', ')
             
              this.reactGrid.slickGrid.invalidate(); 

            return dataContext
          },
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jedną grupę do edycji!');
      }else{
        alert('Nie wybrano grupy do edycji!');
      }
    }else{
        this.compositeEditorInstance?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection: CompositeEditorSelection, dataContext) => {
            if (_selection.gridRowIndexes.length===0){
              let tmp = {...dataContext, id:null}
              ContractorGroupService.addgroup(tmp).then(
                  (data) => {
                    this.reactGrid.filterService.updateFilters([])
                  }
                ).catch(
                  (error) => {
                    try{   
                      if (error && error.response && error.response.data && error.response.data.detail){
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd: " + error.response.data.detail
                        }));
                      }else{          
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd podczas dodawania grupy"
                        }));
                      }
                      
                      var tmp = this.reactGrid.slickGrid.getData().getItems()
                      tmp.splice(0,1);
                      
                      this.reactGrid.slickGrid.getData().setItems(tmp)
                    }catch{
          
                    }
                  }
                )   
            }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }
    
  onCellClicked(_e: Event, args: any) {
    const metadata = this.reactGrid.gridService.getColumnFromEventArguments(args);

    if (metadata.columnDef.id === 'delete') {
      
      if (window.confirm('Czy potwierdzasz usunięcie grupy: ' + metadata.dataContext.name + '?')) {
        ContractorGroupService.deletegroup(metadata.dataContext.id).then(
          () => {
            this.reactGrid.gridService.deleteItemById(metadata.dataContext.id)

            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertInfo: `Usunięto grupę: ${metadata.dataContext.name}`,
            }));
        }

        ).catch(
          () => {
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: `Wystąpił problem przy usuwaniu grupy: ${metadata.dataContext.name}`,
            }));
          }
        )
        
        
      }
    }
  }

  checkItemIsEditable(dataContext: any, columnDef: Column, grid: SlickGrid) {
    const gridOptions = grid.getOptions() as GridOption;
    const hasEditor = columnDef.editor;
    const isGridEditable = gridOptions.editable;
    let isEditable = Boolean(isGridEditable && hasEditor);
  
    if (dataContext && columnDef && gridOptions?.editable) {
      isEditable = authService.isAdmin() 
    }
    return isEditable;
  }

  handleonAddNewRow(_e: Event, args: OnAddNewRowEventArgs) {
     //return true;
  }

  handleOnCompositeEditorChange(_e: Event, args: OnCompositeEditorChangeEventArgs) {
    
  }

  handleOnBeforeEditCell(e: Event, args: any) {
    const { column, item, grid } = args;

    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }

  resizeContent($event:any){
 
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertError: ''
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertInfo: ''
      }));
    }

    return !this.state.gridOptions ? '' : (
       <>
          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
              <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEdit} onChange={(_, data) => this.autoeditchange(data)}  />} label="Auto-edit" />

              
            </div>
            
            
            <div className='gridCenterSubMenu'>
            
           { authService.isAdmin() && <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                  onClick={() => {this.openCompositeModal('create')} 
            }>
                  Dodaj
                </button>
            }
           
              
            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.openCompositeModal('edit')}>
                Edytuj
            </button>
              
            </div><div className='gridRightSubMenu'>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ustawienia domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" onResize={this.resizeContent} style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}
          
          <SlickgridReact gridId="contractorgroup-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onClick={e => { this.onCellClicked(e.detail.eventData, e.detail.args); }}  
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
            onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
            onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
            onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
            
            
          />
          </div>
      </>
    );
  }
}

export default withTranslation()(ContractorGroups);